import React from "react";

export default function DashboardLayout({ children }) {
  return <div className="dashboard-shell">{children}</div>;
}
